import { DataType } from '../types/DataType'
import { ConstructorArgs } from '../types/models'
import { BaseRecord } from './BaseRecord'
import { Item } from './Item'
import { Resource } from './Resource'
import { User } from './User'

export type ConflictConstructorArgs = ConstructorArgs<() => Conflict>

export class Conflict extends BaseRecord {
    readonly recordType = 'conflict'

    type?: string
    subtype?: string
    end?: moment.Moment
    start?: moment.Moment
    title?: string

    constructor(data?: Partial<ConflictConstructorArgs>) {
        super(data)
        if (!data) {
            return
        }

        this.type = data.type ?? undefined
        this.subtype = data.subtype ?? undefined
        this.end = this.propertyFromTimestampArg(data.end)
        this.start = this.propertyFromTimestampArg(data.start)
        this.title = data.title ?? undefined
    }

    clone(overrides?: Partial<ConflictConstructorArgs>): Conflict {
        return new Conflict({ ...this.serializeForClone(), ...overrides })
    }

    static dataType(): DataType {
        return 'conflicts'
    }

    get item(): Item | undefined {
        return this.getForeignRecord('item', Item)
    }
    set item(item: Item | undefined) {
        this.setForeignRecord('item', item)
    }
    get client(): User | undefined {
        return this.getForeignRecord('client', User)
    }
    set client(client: User | undefined) {
        this.setForeignRecord('client', client)
    }
    get resource(): Resource | undefined {
        return this.getForeignRecord('resource', Resource)
    }
    set resource(resource: Resource | undefined) {
        this.setForeignRecord('resource', resource)
    }
}
